/**
 * Floating Action Button (FAB) for opening the chatbot
 */

import React from 'react';
import { Fab, Badge, Tooltip } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import { useTranslation } from 'react-i18next';
import { useIsChatbotAllowed } from '../../hooks/useIsChatbotAllowed';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import {
  toggleChat,
  selectChatbotOpen,
} from '../../features/chatbot/chatbotSlice';

export const ChatButton: React.FC = () => {
  const { t } = useTranslation('chatbot');
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(selectChatbotOpen);
  const isAllowed = useIsChatbotAllowed();

  const handleClick = () => {
    dispatch(toggleChat());
  };

  if (isOpen || !isAllowed) {
    return null; // Hide button when chat is open or not allowed
  }

  return (
    <Tooltip title={t('chatbot.openChat')} placement="left">
      <Fab
        data-testid="chat-button"
        color="primary"
        aria-label={t('chatbot.openChat')}
        onClick={handleClick}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 1000,
        }}
      >
        <Badge color="error" variant="dot" invisible>
          <ChatIcon />
        </Badge>
      </Fab>
    </Tooltip>
  );
};
